//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import sharedMethods from "../../sharedMethods.js";

export default {
  name: "deletemedia",
  props: ["inUsePl", "contentsToDelete", "darkmode"],
  computed: mapGetters(["allMediaFiles"]),

  data() {
    return {
      canDel: false,
    };
  },
  mounted() {
    if (this.inUsePl < 1) {
      this.canDel = true;
    } else {
      this.canDel = false;
    }
  },
  computed: {
    sharedMethods() {
      return sharedMethods;
    },
  },
  methods: {
    // following method is REQUIRED
    // (don't change its name --> "show")
    show() {
      this.$refs.dialog.show();
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide() {
      this.$refs.dialog.hide();
    },

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit("hide");
    },

    onOKClick() {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      this.$emit("onOk");
      // or with payload: this.$emit('ok', { ... })

      // then hiding dialog
      this.hide();
    },

    onCancelClick() {
      // we just need to hide dialog
      this.hide();
    },
  },
};
